import * as Sentry from '@sentry/react'
import React, { useMemo } from 'react'
import { Outlet } from 'react-router-dom'

import { Box, Group, Text } from '@affstore-ds/uikit'

import { getBrandConfig } from '../../../../../config/brands'
import { AdvertiserLogo } from '../../../../../shared/assets'
import { OnboardingToOfferConversionFunnel } from '../../../../../shared/utils'
import { GuestFooter } from '../../../../../widgets'

import { useAuthWrapperStyles } from './AuthWrapper.styled'

const { brandConfig } = getBrandConfig()

export const AuthWrapper = () => {
  const { classes } = useAuthWrapperStyles()

  const advertiserLogo = useMemo(() => {
    const { ADVERTISER_ALIASES_TO_LOGO, COOKIES_PARAMS_OBJECT, getMarketingURLParametersFromCookies } = OnboardingToOfferConversionFunnel
    const advertiserAlias = getMarketingURLParametersFromCookies().get(COOKIES_PARAMS_OBJECT.m_oto_advertiser) || ''

    if (advertiserAlias) {
      const logo = ADVERTISER_ALIASES_TO_LOGO[advertiserAlias]

      if (!logo) {
        Sentry.captureException(new Error(`m_oto_ > Advertiser logo not found. Advertiser: ${advertiserAlias}`))

        return null
      }

      return logo
    }

    return null
  }, [])

  return (
    <>
      <Box
        className={classes.formWrapper}
        maw={502}
        mx="auto"
        px={{ base: 16, md: 24, xl: 32 }}
        py={{ base: 24, lg: 48, md: 48, sm: 48, xs: 24 }}
        w="100%"
      >
        <Group align="center" gap={8} justify="center" mah={20} mt={24} wrap="nowrap">
          <AdvertiserLogo alt="Logo" iconName={brandConfig.logo} size="m" w={120} />
          {advertiserLogo && (
            <Text elementSize="xl" elementVariant="header">
              ×
            </Text>
          )}
          {advertiserLogo}
        </Group>

        <Outlet />
      </Box>

      <GuestFooter />
    </>
  )
}
